import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import AerodynamicForceCalculator from '../components/tools/AerodynamicForceCalculator';

const AerodynamicForceCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="aerodynamic-force-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities / Vehicle Dynamics"
        title="Aerodynamic Force Calculator"
        description="Calculate the aerodynamic drag force and power required to overcome it as a vehicle moves through air, from vehicle speed, drag coefficient, frontal area, air density, and wind conditions."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="aerodynamic-force-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <AerodynamicForceCalculator />
          <ToolGuideCta guidePath="/tools/aerodynamic-force-calculator/guide" toolName="Aerodynamic Force Calculator" />
        </div>
      </section>
    </div>
  );
};

export default AerodynamicForceCalculatorPage;
